namespace Ir.Components.Workbook.Widgets.RichTextWidget {
    interface IViewModel {
        config: WorkbookConfig;
        widget: any;
        onHtmlRendered: Function;
        scrollConfig: DevExpress.ui.dxScrollView.Properties;
    }

    export function getViewModel(this: IViewModel, params: any, componentInfo) {
        this.config = params.config as WorkbookConfig;
        this.widget = params.widget;

        let widget: RichTextWidget = params.widget;
        widget.set$ReportContent(componentInfo.element);
        widget.setup();

        this.scrollConfig = {
            height: "100%"
        };

        this.onHtmlRendered = function (elements, data) {
            let $links = $('a[href*="Link"]', elements);
            for (let $link of $links) {
                let href = $($link).attr("href");
                $($link).removeAttr("href");
                $($link).off("click").on("click", function (e) {
                    e.stopPropagation();
                    const ids = href.match(/-?\d+/g);
                    const workbookId = parseInt(ids[0] as any, 10);
                    const tabId = parseInt(ids[1] as any, 10);

                    if (workbookId === workbook.workbookConfig.workbookId()) {
                        if (tabId !== 0) {
                            workbook.workbookConfig.setActiveTab(tabId);
                        }
                    }
                    else {
                        if (workbookId === 0) {
                            DevExpress.ui.notify("Workbook or Tab not found");
                            return;
                        }

                        let o = {
                            url: `${urlConfigs.tabs}CanAccessWorkbook`,
                            data: {
                                userId: loggedUser.id(),
                                workbookId: workbookId,
                                companyId: loggedUser.companyId()
                            },
                            dataType: "json",
                            async: false,
                        } as RequestServerParams
                        o.successFunction = function (data) {
                            if (data.success) {
                                let url = `/wb/edit/${workbookId}`;
                                let params = [];

                                if (tabId !== 0) {
                                    params.push(`tabId=${tabId}`);
                                }

                                if (irSettings.multiTenant) {
                                    params.push(`companyId=${loggedUser.companyId()}`);
                                }

                                if (params.length > 0) {
                                    url += `?${params.join("&")}`;
                                }

                                document.location = url;
                            }
                            else {
                                DevExpress.ui.notify(data.message);
                            }
                        };
                        o.failureFunction = function () {
                            DevExpress.ui.notify("Workbook not found or no access permission");
                        };

                        irGlobal.requestServer(o);
                    }
                });
            }
        };
    }
}